import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"bg-dark text-center my-5\"><div class=\"py-5 image-header opacity-bg\" style=\"background-image:url(&#39;/images/restaurants-bg.png&#39;);\"><div class=\"container container-fluid\"><div class=\"row\"><div class=\"col-md-10 offset-md-1\"><h4 class=\"text-white fw-bold mb-4\">Find a restaurant<br> and enjoy dining out with Picado</h4><div class=\"row\"><div class=\"col-md-5 d-flex\"><select class=\"form-select rounded-left white-select border-end border-0\"><option selected>Cuisine</option><option value=\"1\">One</option><option value=\"2\">Two</option><option value=\"3\">Three</option></select><select class=\"form-select rounded-right white-select border-0\"><option selected>City</option><option value=\"1\">One</option><option value=\"2\">Two</option><option value=\"3\">Three</option></select></div><div class=\"col-md-4\"><div class=\"search-input position-relative\"><input type=\"text\" class=\"form-control rounded-5 border-0\" placeholder=\"Search by retaurant name\"><i class=\"fas fa-search text-secondary\"></i></div></div><div class=\"col-md-3\"><button type=\"button\" class=\"btn btn-primary btn-sm rounded-5 px-3 me-2 fw-bold w-100\">Find a table</button></div></div></div></div></div></div></section>", 1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "container container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row restaurants-list" }
const _hoisted_7 = { class: "card shadow-sm rounded-3 border-0 h-100" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "card-body px-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-success fw-bold small mb-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }),
  /*#__PURE__*/_createTextVNode(" Available")
], -1)
const _hoisted_11 = { class: "card-title fw-bold mb-1" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  href: "#",
  class: "btn btn-secondary rounded-3 w-100 fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_list_loader = _resolveComponent("list-loader")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _hoisted_2,
    (_ctx.all_restaurants)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_restaurants, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "col-lg-3 col-md-4 col-sm-6 mb-4"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        src: item.featured_photo_thumbnails.cover_small,
                        class: "card-img-top",
                        alt: item.name
                      }, null, 8, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("h6", _hoisted_11, _toDisplayString(item.name), 1),
                        _createElementVNode("p", _hoisted_12, [
                          (item.cuisines && item.cuisines.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(item.cuisines[0].name), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_13
                              ], 64))
                        ]),
                        (item.has_booking_only)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.restaurantURL(item.id, item.name),
                              class: "btn btn-primary rounded-3 w-100 fw-bold"
                            }, "Book Now", 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("a", _hoisted_15, "View Details"))
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_list_loader, { key: 1 })),
    _createVNode(_component_Footer)
  ]))
}